import React from 'react';
import { FormControl, FormGroup } from "react-bootstrap";

function FieldGroup( { id, label, help, isRequired, errorMessage, ...props } ) {
    return (
        <FormGroup id={ id } className={ props.className }>
            <label className={ props.name + "-label" }>
                { label }
                { isRequired === true && <span style={ { color: "red" } }> *</span> }
            </label>
            { errorMessage &&
            <div className={ "errorMessage" }>
                <span>{ errorMessage }</span>
            </div> }
            { help && <span className={ "helpBlock" }>{ help }</span> }
            <FormControl { ...props } />
        </FormGroup>
    );
}

export default FieldGroup;
